module.exports = __webpack_public_path__ + "static/media/woman-walking.5fbd6e82.png";